import { TriggerEvent } from './trigger-event';
import { MessageCondition } from '../shared/message-condition/message-condition.model';
import { TriageAction } from './triage-action';

export class TriageRules {
  static accountsMap = new Map();

  constructor() {
    this.rules = [];
  }

  addRule(rule) {
    rule._getSitesSelectedPreview();
    this.rules.push(rule);
  }

  deleteRule(index) {
    this.rules.splice(index, 1);
  }

  updateRule(index, rule) {
    rule._getSitesSelectedPreview();
    this.rules[index] = rule;
  }

  getRuleDeepCopy(index) {
    return TriageRule.fromBackEnd(angular.copy(this.rules[index]));
  }

  lastRuleIndex() {
    return this.rules.length - 1;
  }


  static fromBackEnd(backendRules, accountsMap) {
    TriageRules.accountsMap = accountsMap;
    const result = new TriageRules();
    backendRules.forEach(rule => result.addRule(TriageRule.fromBackEnd(rule)));
    return result;
  }
}


class TriageRule {

  constructor(id) {
    this.id = id;
    this.type = null;
  }

  isDefaultType() {
    return this.type === 'default';
  }

  isCustomType() {
    return this.type === 'custom';
  }

  isMigratedType() {
    return this.type === 'migrated';
  }

  // Show only 2 account + n others.
  _getSitesSelectedPreview() {
    // Show only 2 account + n others.
    this.sitesSelectedPreview = [].concat(this.sites || []).slice(0, 2).map(key => {
      if (TriageRules.accountsMap.has(key)) {
        return TriageRules.accountsMap.get(key)
      }
    }).filter(i => i);
    this.siteIds = [];
    this.siteGroupIds = [];
    (this.sites || []).forEach(key => {
      if (/site\|/.test(key)) {
        this.siteIds.push(+key.replace('site|', ''));
      } else if (/siteGroup\|/.test(key)) {
        this.siteGroupIds.push(+key.replace('siteGroup|', ''));
      }
    })
  }

  static fromBackEnd(backendRule) {
    let result;
    if (backendRule.type === 'default') {
      result = new NonEditableDefaultRule(backendRule.id, backendRule.code);
    } else {
      result = new CustomTriageRule(backendRule);
    }
    result.isActive = backendRule.isActive;
    return result;
  }
}


class NonEditableDefaultRule extends TriageRule {

  constructor(id, code) {
    super(id);
    this.type = 'default';
    this.code = code;
    this.title = 'triage_config/default_rules/' + code;
    this.actionLabel = 'triage_config/actions/' + code; // this is agreed with the backend for the case of migrated rules
    // Default rules descriptions are hardcoded here, so that we can change them in the future without having to migrate configs in the database for all sites
    switch (code) {
      case 'archive_previous_in_conversation':
        this.sites = [];
        this.siteIds = [];
        this.siteGroupIds = [];
        this.conditionLabel = 'triage_config/default_rules/received_private_channel';
        break;
      case 'propagate_routing_tag':
      case 'propagate_qualifying_tags':
      case 'auto_reassign':
        this.sites = [];
        this.siteIds = [];
        this.siteGroupIds = [];
        this.conditionLabel = null;
        break;
      default:
        // Nothing to add for custom rules
        break;
    }
  }
}

// Note that this class is also used for type === 'migrated' rules
export class CustomTriageRule extends TriageRule {

  // builds a new custom rule, copying properties from a given ruel from the backend,
  // or with decent initial properties so that the UI doesn't crash
  constructor(backendRule) {
    super(backendRule.id);

    this.type = backendRule.type || 'custom';
    this.title = backendRule.title || '';
    this.isActive = backendRule.isActive || false;
    this.siteIds = backendRule.siteIds || []; // empty array means all sites
    this.siteGroupIds = backendRule.siteGroupIds || []; // empty array means all site groups
    const siteKeys = (this.siteIds || []).map(id => `site|${id}`);
    const siteGroupKeys = (this.siteGroupIds || []).map(id => `siteGroup|${id}`);
    // Show group sites in first.
    this.sites = siteGroupKeys.concat(siteKeys);
    this._getSitesSelectedPreview();

    this.conditionsLogicOperator = backendRule.conditionsLogicOperator || 'AND'; // can also be 'OR'

    this.triggerEvent = backendRule.triggerEvent ? TriggerEvent.fromBackEnd(backendRule.triggerEvent) : new TriggerEvent();
    this.conditions = [];
    this.actions = [];
    if (backendRule.conditions) {
      backendRule.conditions.forEach(condition => this.addCondition(MessageCondition.fromBackEnd(condition)));
    }
    if (backendRule.actions) {
      backendRule.actions.forEach(action => this.addAction(TriageAction.fromBackEnd(action)));
    }
  }


  initIsAllSites() {
    this.isAllSites = !this.siteIds.length && !this.siteGroupIds.length;
    this._getSitesSelectedPreview();
  }

  allSitesChanged() {
    if (this.isAllSites) {
      this.siteIds = [];
      this.siteGroupIds = [];
      this.sites = [];
    }
    this._getSitesSelectedPreview();
  }

  addCondition(condition) {
    this.conditions.push(condition);
  }

  deleteCondition(index) {
    this.condition.splice(index, 1);
  }

  addAction(action) {
    this.actions.push(action);
  }

  deleteAction(index) {
    this.actions.splice(index, 1);
  }

}
